import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CheckboxAdapter from '../CheckboxAdapter.jsx';
import { retrieveSimplifiedEmployees } from '../../modules/employees.js';

const mapDispatchToProps = { retrieveSimplifiedEmployees };

const IncludeEmployeesCheckbox = ({
  group,
  isChecked,
  handleSelect,
  disabledSelectAll,
  retrieveSimplifiedEmployees,
}) => {
  const [checked, setChecked] = useState(isChecked);

  const onChange = () => {
    if (checked) {
      handleSelect(group.id, []);
      setChecked(false);
    } else {
      retrieveSimplifiedEmployees({ autocomplete: false, groupIds: [group.id] })
        .then(({ result, entities }) => {
          handleSelect(
            group.id,
            result.employees,
            entities.employeesAutocomplete
          );
          setChecked(true);
        })
        .catch(() => setChecked(false));
    }
  };

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  return (
    <CheckboxAdapter
      customClass="m-t-8 m-b-6"
      input={{
        checked,
        onChange: () => onChange(),
      }}
      disabled={!group.employeeIds.length || disabledSelectAll}
      label="Include All Employees"
    />
  );
};

export default connect(null, mapDispatchToProps)(IncludeEmployeesCheckbox);
